import axios from "axios";
import { Message } from "element-ui";
//写cookie
const setCookie = function (name, value) {
  let Days = 1;
  let exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
};

//获取cookie
const getCookie = function (name) {
  let arr = [];
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  } else {
    return null;
  }
};

//删除cookie
const delCookie = function (name) {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

//写日志
const setLog = function (content) {
  const username = getCookie("username");
  const param = {
    username: username,
    content: content,
  };
  axios.post("/api/log", param).then(function (response) {
    if (response.status === 200 && response.data.errcode === 0) {
      console.log("set log success");
    }
  });
};

//语言
const getLang = function () {
  const defalutLang =
    navigator.language.indexOf("en") !== -1 ? "en-US" : "zh-CN";
  const lang = getCookie("lang") ?? defalutLang;
  return lang;
};

//消息提示
const message = function (text, type) {
  Message({
    offset: 80,
    showClose: true,
    message: text,
    type: type,
  });
};

export { setCookie, getCookie, delCookie, setLog, getLang, message };
